<router-outlet>
  <app-loader />
  <p-toast position="top-center" />
</router-outlet>


